export const ROOT_ROUTE_SEGMENTS = {
  BUILDER_USER: "builderuser",
  USER_SERVICE: "userservice",

  SM_TEMPLATES: "sm_templates",
  SCREEN_TEMPLATES: "screen_templates",

  THEME: "theme",
  THEME_ID_PARAM: `:themeId`,

  CHARTS: "charts",
  CHART_EDITOR: "chartEditor",

  PROMPT: "prompt",
  CLUSTER_MANAGER: "clustermanager",
  METRICS: "metrics",
  ORGANIZATION: "organization",
  PROXY_ROUTES: "proxy",
  RELEASES: "releases",
  USER_MANAGEMENT: "user_management",
  USER_LOGS: "user-logs"
};

export const ORG_ROUTE_SEGMENTS = {
  ORG_ID_PARAM: ":orgId", // /organization/:orgId

  GROUP_USERS: "appgroupuser", // /organization/:orgId/appgroupuser
  STRUCTURE: "orgstructure", // /organization/:orgId/orgstructure
  USERS: "orgusers", // /organization/:orgId/orgusers
  ROLES: "orgroles", // /organization/:ordId/orgroles

  THEME: "theme", // /organization/:orgId/theme
  THEME_ID_PARAM: ":themeId", // /organization/:orgId/theme/:themeId

  APPLICATIONS: "app", // /organization/:orgId/app/
  MONITOR: "monitor" // /organization/:orgId/monitor
};
